import React from "react";
import { SensorDataFile } from "@shared/models";

import "./index.scss";

interface SensorDataSessionFilesItemProps {
  file: SensorDataFile;
}

const SensorDataSessionFilesItem = (props: SensorDataSessionFilesItemProps) => {
  const { file } = props;

  return (
    <div className="sensor-data-session-file" style={{ borderLeft: `5px solid ${file.color}` }}>
      <div className="left-sensor-data-session-file" style={{ color: file.color }}>
        <div className="file-name">{file.custom_name || file.name}</div>
      </div>
      <div className="right-sensor-data-session-file">
        <div className="value-item">
          <div className="label">Rate</div>
          <div className="text">{file.rate}</div>
        </div>
        <div className="value-item">
          <div className="label">Time Range</div>
          <div className="text">
            {file.start_time} - {file.end_time}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SensorDataSessionFilesItem;
